import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AppLauncherService } from '../services/app-launcher.service';
import { AppUserClaimsService } from '../services/app-user-claims.service';
import { switchMap } from 'rxjs/operators';
import { UserRoles } from '../constants/constants';
import { AppStateService } from  '../services/app-state.service';
import { SupportPortalService } from '../services/support-portal.service';
import { XLaunchService } from '../services/x-launch.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerAdminGuard  {
  constructor(
    private appUserClaimsSvc: AppUserClaimsService,
    private appLauncherService: AppLauncherService,
    private route: Router,
    private appStateService: AppStateService,
    private supportPortalService: SupportPortalService,
    private xlaunchService: XLaunchService
  ) {
    console.log("PartnerAdminGuard - constructor")
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
      console.log("PartnerAdminGuard - state")
      return this.CheckIfAccountIsSetInAppLauncher()
                .pipe(
                  switchMap( value =>  { return this.checkForRoleAndCorrectId(state)  } ));
  }

  checkForRoleAndCorrectId(state: RouterStateSnapshot){
    const claims = this.appUserClaimsSvc.getClaims();
    const assumed = this.appUserClaimsSvc.isAssumedRole();
    const supportMode = this.appStateService.getSupportPortalMode();
    const unlockedRoutes = this.supportPortalService.getUnlockedRoutes();
    const xlaunch = this.xlaunchService.isXLaunchedFromBoss();

    if (claims.role === UserRoles.PARTNER_ADMIN && this.appLauncherService.getAccount().accountId === claims.accountId && !supportMode) {
        return of(true);
    } else if (claims.role === UserRoles.USER && state.url === '/' && !supportMode) {
        return of(true);
    } else if(supportMode && assumed && unlockedRoutes.includes(state.url)){
      return of(true);
    } else if ( xlaunch == true ){
      return of(true);
    } else {
      console.log("Redirecting to Navigations Error"); //trying to debug an issue
        this.route.navigate(['navigationError']);
        return of(false);
    }
  }

  CheckIfAccountIsSetInAppLauncher() {
    if ( !!this.appLauncherService.getAccount() ) {
      return of(true);
    } else {
      return this.appLauncherService.accountSet.asObservable();
    }
  }
}
